// AUTO-GENERATED by gen-env.ts from BUN_PUBLIC_* — do not edit.
export const env = {
	"SUPABASE_URL": "https://gmjaadbhawxesrnhzbsl.supabase.co",
	"SUPABASE_ANON_KEY": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtamFhZGJoYXd4ZXNybmh6YnNsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ2MjY4ODksImV4cCI6MjA5MDIwMjg4OX0.Hebl3vqFeg0Mi3SpFypdtBtYoOloMVFuUZ7ZhmjOHT4",
	"API_BASE_URL": "https://slims-api.slims.workers.dev"
} as const;
